// extracted by mini-css-extract-plugin
export var category = "search-module--category--89323";
export var heading = "search-module--heading--82334";
export var search = "search-module--search--b54ea";
export var search_contents = "search-module--search_contents--bd779";
export var search_subcontents = "search-module--search_subcontents--cde55";
export var tag = "search-module--tag--b3ca6";